import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="page narrow" data-testid="web-not-found">
      <h1>Page not found</h1>
      <p className="muted">That page does not exist or moved.</p>
      <p>
        <Link to="/directory">Go to the partner directory</Link>
      </p>
    </div>
  )
}
